import React from 'react';
import './style.css';
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton';
import AlarmIcon from '@material-ui/icons/Alarm';

//var audio = new Audio('./music.mp3');
//audio.play();

class Clock extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            date: new Date(),
            on: false,
            time: 25,
            seconds: 25 * 60,
            start: false,
            restart: false,
            alarm: 1
        
        };
        this.ChangeState = this.ChangeState.bind(this)
        this.ChangeStart = this.ChangeStart.bind(this)
        this.ChangeRestart = this.ChangeRestart.bind(this)
    }

    ChangeState() {
        this.setState(prevState => {
         console.log("Pomodoro Started")
         return {
             on: !prevState.on
         }
     })
 }

 ChangeStart() {
    this.setState(prevState => {
     console.log("Pomodoro Actually Started")
     return {
         start: !prevState.start
     }
 })
}

ChangeRestart() {
    this.setState(prevState => {
     console.log("Pomodoro ReStarted")
     return {
         restart: !prevState.restart,
         time: 25,
         seconds: 25 * 60
     }
 })
}

componentDidMount(){
        this.timer = setInterval(
            () => this.setState({date: new Date()}),
            1000
        );
        console.log(this.state.start)
      
            this.time = setInterval(
                () => {
                    
                    if (this.state.start && this.state.seconds != -1){
                        this.setState(
                    {
                        seconds: this.state.seconds - 1,
                        time: Math.floor((this.state.seconds - 1) / 60),
                    }
                )
                    }
                else {
                    this.setState(
                        {
                            seconds: this.state.seconds,
                            time: Math.floor(this.state.seconds / 60),
                            
                        }
                    )
                }
                },1000);
                
    }
componentWillUnmount(){
        clearInterval(this.timer);
        clearInterval(this.time);
    }

render(){
    let seconds = this.state.seconds % 60
    seconds = seconds < 10 ? '0' + seconds : seconds
    let started = this.state.start
    started = started ? 'Pause': 'Start'
    if (this.state.seconds == -1){
        alert("25 Minutes has Passed... Take a Break... Click OK to Continue")
        console.log("Break Time")
        this.ChangeRestart()
    }
    if (this.state.on){   
    return( 
        <div className="clock">
        <div className="timer">{this.state.time}:{ seconds }</div>
        <IconButton color="secondary" aria-label="add an alarm" onClick={this.ChangeState}>
        <AlarmIcon />
      </IconButton>
        <Button variant="outlined" color="inherit" onClick={this.ChangeStart}>{ started }</Button>
        &nbsp;
        <Button variant="outlined" color="inherit" onClick={this.ChangeRestart}>Restart</Button>
        </div>
    )
    } else {
        return(

            <div className="clock">
            <div className="timer">{this.state.date.toLocaleTimeString()}</div>
            <IconButton color="secondary" aria-label="add an alarm" onClick={this.ChangeState}>
        <AlarmIcon />
        </IconButton>
        </div>
        )
    }
}
}
export default Clock